<template>
  <div class="user-list">
    <div class="content">
      <a-breadcrumb class="breadcrumb">
        <a-breadcrumb-item>
          <router-link to="/">
            <a-icon type="home" />
            <span>首页</span>
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>{{ bankName }}用户列表</a-breadcrumb-item>
      </a-breadcrumb>

      <a-row :gutter="16">
        <!-- 左侧用户详情/新增 -->
        <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="4">
          <div class="user-detail-panel" v-if="selectedUser">
            <user-detail-form :user="selectedUser" mode="edit" :platform="platform" @save="handleSaveUserDetail"
              @cancel="cancelEditUser" ref="userDetailForm" />
          </div>
          <div class="user-detail-panel" v-else-if="isAddingUser">
            <user-detail-form mode="add" :platform="platform" :user="{}" @save="handleAddUser" @cancel="cancelAddUser"
              ref="userDetailForm" />
          </div>
          <div class="empty-detail" v-else>
            <div class="empty-actions">
              <a-empty description="请选择一个用户查看详情或添加新用户" />
              <a-button type="primary" @click="showAddUserForm">
                <a-icon type="user-add" />添加新用户
              </a-button>
            </div>
          </div>
        </a-col>

        <!-- 右侧用户列表 -->
        <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="20">
          <!-- 搜索表单 -->
          <div class="search-form">
            <a-form layout="inline">
              <a-form-item>
                <a-button type="primary" style="margin-left: 8px" @click="showAddUserForm">
                  <a-icon type="plus" />添加用户
                </a-button>
                <!-- 公共配置 -->
                <a-button type="primary" style="margin-left: 8px" @click="showCommonConfigModal = true">
                  <a-icon type="plus" />公共配置
                </a-button>
              </a-form-item>
            </a-form>
          </div>

          <vxe-grid v-bind="userTableOptions" @current-row-change="currentRowChangeEvent" @cell-click="cellClickEvent" @cell-dblclick="cellDblclickEvent">

          </vxe-grid>

          <!-- <a-table :columns="columns" :data-source="userData" :pagination="pagination" :loading="loading"
            :row-class-name="rowClassName" @change="handleTableChange" :customRow="customRow">
            <template slot="status" slot-scope="text, record">
              <a-switch :checked="record.status === 'normal'" :loading="record.statusLoading"
                @change="(checked) => handleStatusChange(checked, record)" checked-children="正常"
                un-checked-children="隐藏" />
            </template>
<template slot="operation" slot-scope="text, record">
              <a-space>
                <a-button type="link" @click="handleCopy(record)">
                  <a-icon type="copy" />复制
                </a-button>
                <a-button type="link" @click="handleDelete(record)">
                  <a-icon type="delete" />删除
                </a-button>
              </a-space>
            </template>
</a-table> -->


        </a-col>
      </a-row>
    </div>

    <!-- 公共配置模态框 -->
    <a-modal title="公共配置" :visible="showCommonConfigModal" @cancel="showCommonConfigModal = false" :footer="null"
      width="70vw">
      <common-config :platform="platform" />
    </a-modal>

  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { platformMap } from '@/config/tableColumns'
import userColumns from '@/config/userColumns.json'
import request from '@/utils/request'
import { API } from '@/config/api'
import CommonConfig from '@/components/bank-configs/CommonConfig.vue'
import UserDetailForm from '@/components/UserDetailForm.vue'
import { VxeUI } from 'vxe-pc-ui'



export default {
  name: 'UserList',
  components: {
    CommonConfig,
    UserDetailForm
  },
  data() {
    return {
      loading: false,
      userData: [],
      pagination: {
        current: 1,
        pageSize: 99999,
        total: 0,
        showSizeChanger: true,
        showTotal: total => `共 ${total} 条记录`,
        pageSizeOptions: ['10', '20', '30', '50'],
        showQuickJumper: true
      },
      searchForm: {
        username: '',
        name: '',
        remark: '',
      },
      columns: [],
      addUserLoading: false,
      addUserForm: this.$form.createForm(this),
      showCommonConfigModal: false,
      platform: this.$route.params.platform,
      selectedUser: null,
      isAddingUser: false,
      userTableOptions: {
        id: 'userTable',
        rowConfig: {
          isCurrent: true,
          isHover: true
        },
        size: 'mini',
        columns: [],
        data: [],
        border: true,
        showOverflow: true,
        height: 800,
        scrollY: {
          enabled: true,
          gt: 0
        },
        resizableConfig: {
          isDblclickAutoWidth: true
        },
        columnConfig: {
          resizable: true,
          drag: true
        },
        customConfig: {
          storage: true
        },
        menuConfig: {
          body: {
            options: [
              [
                { code: 'copy', name: '复制' },
                { code: 'delete', name: '删除' },
              ]
            ]
          }
        }
      },


    }
  },
  computed: {
    bankName() {
      return platformMap[this.$route.params.platform] || '未知平台'
    },
    _userTableOptions() {
      this.userTableOptions.data = this.userData

      return this.userTableOptions
    }
  },
  watch: {
    '$route.params.platform': {
      immediate: true,
      handler(platform) {
        this.columns = userColumns[platform]
        console.log('platform', platform)
        console.log('this.columns', this.columns)
        this.pagination.current = 1
        this.fetchUserData()
      }
    }
  },
  methods: {
    // 设置行的类名
    rowClassName(record) {
      return record.id === (this.selectedUser && this.selectedUser.id) ? 'selected-row' : '';
    },
    customRow(record) {
      return {
        on: {
          click: () => {
            this.handleSelectUser(record);
          },
          dblclick: () => {
            this.$router.push(`/transfer-record/${this.$route.params.platform}/${record.id}`);
          }
        }
      }
    },
    // 选择用户
    handleSelectUser(record) {
      this.isAddingUser = false;
      this.selectedUser = { ...record };
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination = { ...this.pagination, ...pagination }
      this.fetchUserData()
    },
    async fetchUserData() {
      this.loading = true
      try {
        const params = {
          platform: this.$route.params.platform,
          page: this.pagination.current,
          limit: this.pagination.pageSize,
          sort: 'id desc',
          ...this.searchForm
        }

        const res = await request.post(API.USER_LIST, params)
        const { total, data } = res.data

        this.pagination.total = total

        this.userData = data

        this.userTableOptions.data = this.userData

        console.log('this.userTableOptions.data', this.userTableOptions)
      } catch (error) {
        this.$message.error(error.message || '获取数据失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      // filter userData
      this.userTableOptions.data = this.userData.filter(item => {
        return item.username.includes(this.searchForm.username) || item.name.includes(this.searchForm.name) || item.remark.includes(this.searchForm.remark)
      })

      console.log('this.userTableOptions.data', this.userTableOptions)
    },
    handleReset() {
      this.searchForm = {
        username: '',
        name: '',
        remark: '',
      }
      this.handleSearch()
    },
    // 处理状态切换
    async handleStatusChange(checked, record) {
      // 设置当前记录的状态为加载中
      record.statusLoading = true

      try {
        const newStatus = checked ? 'normal' : 'hidden'
        const res = await request.post(API.USER_SET_STATUS, {
          platform: this.$route.params.platform,
          id: record.id,
          username: record.username,
          status: newStatus
        })

        if (res.code === 1) {
          this.$message.success(`用户状态已更新为${checked ? '正常' : '隐藏'}`)
          // 只有在接口返回成功后才修改状态
          record.status = newStatus

          // 如果当前选中的是这个用户，也更新选中用户的状态
          if (this.selectedUser && this.selectedUser.id === record.id) {
            this.selectedUser.status = newStatus;
          }
        } else {
          this.$message.error(res.msg || '更新状态失败')
          // 不修改状态，保持原状态
        }
      } catch (error) {
        this.$message.error('更新状态失败: ' + error.message)
        // 不修改状态，保持原状态
      } finally {
        record.statusLoading = false
      }
    },
    // 处理保存用户详情
    async handleSaveUserDetail(updatedUser) {
      try {
        // 直接使用updatedUser，它已经包含了所有需要的字段
        const params = updatedUser;

        const res = await request.post(API.USER_UPDATE, params);

        if (res.code === 1) {
          this.$message.success('用户信息更新成功');

          // 更新本地selectedUser
          this.selectedUser = { ...updatedUser };

          // 重置搜索条件并刷新列表，确保能看到更新后的用户
          this.searchForm = {
            username: '',
            name: '',
            remark: '',
          };
          this.fetchUserData(); // 刷新用户列表

          // 通知子组件保存完成
          this.$refs.userDetailForm.setSaving(false);
        } else {
          this.$message.error(res.msg || '更新用户信息失败');
          this.$refs.userDetailForm.setSaving(false);
        }
      } catch (error) {
        this.$message.error('更新用户信息失败: ' + error.message);
        this.$refs.userDetailForm.setSaving(false);
      }
    },
    handleView(record) {
      // 点击查看按钮时，选中该用户
      this.handleSelectUser(record);
    },
    handleCopy(record) {
      this.$confirm({
        title: '复制用户',
        content: `确定要复制用户 ${record.name} 吗？复制后将创建一个相同信息的新用户。`,
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          try {
            this.loading = true;
            const res = await request.post(API.USER_COPY, {
              platform: this.$route.params.platform,
              id: record.id
            });

            if (res.code === 1) {
              this.$message.success('复制用户成功');
              this.fetchUserData(); // 刷新用户列表
            } else {
              this.$message.error(res.msg || '复制用户失败');
            }
          } catch (error) {
            this.$message.error('复制用户失败: ' + error.message);
          } finally {
            this.loading = false;
          }
        }
      });
    },
    handleDelete(record) {
      this.$confirm({
        title: '确认删除',
        content: `确定要删除用户 ${record.name} 吗？`,
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          try {
            this.loading = true;
            const res = await request.post(API.USER_DELETE, {
              platform: this.$route.params.platform,
              id: record.id
            });

            if (res.code === 1) {
              this.$message.success('删除用户成功');

              // 如果删除的是当前选中的用户，清空选中
              if (this.selectedUser && this.selectedUser.id === record.id) {
                this.selectedUser = null;
              }

              this.fetchUserData(); // 刷新用户列表
            } else {
              this.$message.error(res.msg || '删除用户失败');
            }
          } catch (error) {
            this.$message.error('删除用户失败: ' + error.message);
          } finally {
            this.loading = false;
          }
        }
      });
    },
    // 显示添加用户表单
    showAddUserForm() {
      this.selectedUser = null;
      this.isAddingUser = true;
      this.addUserForm.resetFields();
    },
    // 取消添加用户
    cancelAddUser() {
      this.isAddingUser = false;
      this.addUserForm.resetFields();
    },
    // 处理添加用户
    async handleAddUser(userData) {
      this.addUserLoading = true;

      try {
        // 直接使用userData，它已经包含了platform信息
        const params = userData;

        // 使用正确的API接口：USER_ADD
        const response = await request.post(API.USER_ADD, params);

        if (response.code === 0 || response.code === 1) {
          this.$message.success('添加用户成功');
          this.isAddingUser = false;

          // 重置搜索条件并刷新列表，确保能看到新添加的用户
          this.searchForm = {
            username: '',
            name: '',
            remark: '',
          };
          this.pagination.current = 1;
          this.fetchUserData(); // 刷新用户列表
        } else {
          this.$message.error(response.msg || response.message || '添加用户失败');
        }
      } catch (error) {
        console.error('添加用户失败', error);
        this.$message.error('添加用户失败，请稍后重试');
      } finally {
        this.addUserLoading = false;
        if (this.$refs.userDetailForm) {
          this.$refs.userDetailForm.setSaving(false);
        }
      }
    },
    cancelEditUser() {
      this.selectedUser = null;
    },
    initUserTableOptionsColumns() {
      // columns: [
      //   { type: 'seq', width: 70 },
      //   { field: 'name', title: 'Name' },
      //   { field: 'sex', title: 'Sex' },
      //   { field: 'age', title: 'Age' }
      // ]
      this.userTableOptions.columns = userColumns[this.$route.params.platform].map(column => ({
        field: column.key,
        title: column.title,
        width: column.width,
        filters: [{ data: '' }],
        filterRender: {
          name: 'VxeInput'
        }
      }))
    },
    // 注册表格右键事件
    registerTableMenuEvents() {
      var _this = this
      VxeUI.menus.add('copy', (res) => {
        _this.handleCopy(res.row)
      })
      VxeUI.menus.add('delete', (res) => {
        _this.handleDelete(res.row)
      })
    },
    currentRowChangeEvent({ rowIndex }) {
      console.log(`行选中事件 ${rowIndex}`)
    },
    cellClickEvent({ row, column }) {
      // console.log(`单元格点击事件 ${row.id} ${column.key}`)
      this.handleSelectUser(row)
      this.selectedUser = row
    },
    cellDblclickEvent({ row, column }) {
      this.$router.push(`/transfer-record/${this.$route.params.platform}/${row.id}`);
    },
    // 监听快捷键
    handleKeydownEvent(event) {
      console.log(`快捷键事件 ${event.ctrlKey} ${event.key}`)
      // 监听 Ctrl+C：复制当前选中的用户
      if (event.ctrlKey && event.key === 'c') {
        console.log('ctrl+c' , 'ctrl+c')
        // if (this.selectedUser) {
        //   this.handleCopy(this.selectedUser)
        // } else {
        //   this.$message.warning('请先选择一个用户')
        // }
      }
      // 监听 Ctrl+V：打开添加用户表单(模拟粘贴用户)
      // if (event.ctrlKey && event.key === 'v') {
      //   this.showAddUserForm()
      // }
    },
    // 注册键盘快捷键事件
    registerKeydownEvent() {
      // 添加全局事件监听
      document.addEventListener('keydown', this.handleKeydownEvent)
    },
  },
  created() {
    this.initUserTableOptionsColumns()
    this.fetchUserData()
    this.registerTableMenuEvents()
    this.registerKeydownEvent()
  },
  // 组件销毁前移除事件监听，防止内存泄漏
  beforeDestroy() {
    // 移除全局事件监听
    document.removeEventListener('keydown', this.handleKeydownEvent)
  }
}
</script>

<style scoped>
.user-list {
  /* 外层 .app-main 已有 padding，这里不再加，让 .content 占满宽度 */
}

.content {
  background: #fff;
  padding: 24px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.breadcrumb {
  margin-bottom: 16px;
  text-align: left;
}

.search-form {
  margin-bottom: 24px;
}

.table-toolbar {
  margin-bottom: 16px;
}

.add-form {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

:deep(.wide-modal) {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 用户详情面板样式 */
.user-detail-panel {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: 100%;
  min-height: 500px;
  overflow-y: auto;
}

.empty-detail {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: 100%;
  min-height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.empty-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

/* 选中行样式 */
:deep(.selected-row) {
  background-color: #e6f7ff;
}

/* 新增用户表单样式 */
.add-user-form {
  padding: 0 8px;
}

.form-section {
  margin-bottom: 24px;
  padding: 16px;
  background-color: #fafafa;
  border-radius: 4px;
  border: 1px solid #f0f0f0;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #1890ff;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.form-actions {
  margin-top: 24px;
  text-align: center;
  padding: 16px 0;
  border-top: 1px solid #f0f0f0;
}

/* 响应式布局调整 */
@media (max-width: 1200px) {

  .user-detail-panel,
  .empty-detail {
    min-height: 400px;
  }
}

@media (max-width: 768px) {
  .content {
    padding: 16px;
  }

  .form-section {
    padding: 12px;
  }
}
</style>